import { get } from "env-var";

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const APP_VERSION = require("../../package.json").version;

export class AppConfig {
  // App ==================================================================================
  static readonly AppStage = get("REACT_APP_STAGE").asEnum(["prod", "dev"]);
  static readonly TixApiUrl = get("REACT_APP_SKEY_TIX_API_URL").required().asUrlString();
  static readonly CaptchaPublicKey = get("REACT_APP_CAPTCHA_PUBLIC_KEY").asString();
  static readonly CaptchaDisabled = get("REACT_APP_CAPTCHA_DISABLED").default("true").asBool();

  // Other ================================================================================
  static readonly DisableEslintPlugin = get("DISABLE_ESLINT_PLUGIN").default("true").asBool();
  static readonly i18nDebugMode = get("REACT_APP_I18N_DEBUG_MODE").default("false").asBool();
  static readonly GlobalTimeout = 1000 * 8; //[ms]
}
